import { z } from 'zod';

export const FILTER_LOAN_STATES = ['active', 'completed'] as const;

export type FilterLoanStatesKeys = (typeof FILTER_LOAN_STATES)[number];

export const clientLoansFilterFormSchema = z.object({
	loanState: z.enum(FILTER_LOAN_STATES).prefault('active'),
});

export type ClientLoansFilterForm = z.infer<typeof clientLoansFilterFormSchema>;
